import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { providerFailure } from '../provider-error.js';
import { fetchFundingQuote } from './fetch-funding-quote.js';
/** An unresolved pre-payment identity check can be polled without creating another attempt. */
export function usePendingVerification(options) {
  const $ = _c(10);
  const {
    enabled,
    operation,
    operationId,
    provider,
    active,
    onQuote,
    setError,
    setProviderFailure
  } = options;
  let t0;
  let t1;
  if ($[0] !== active || $[1] !== enabled || $[2] !== onQuote || $[3] !== operation || $[4] !== operationId || $[5] !== provider || $[6] !== setError || $[7] !== setProviderFailure) {
    t0 = () => {
      if (!enabled || !operation || !operationId) {
        return;
      }
      const controller = new AbortController();
      const timer = setInterval(() => {
        if (active.current) {
          return;
        }
        active.current = controller;
        fetchFundingQuote(provider, operation, controller.signal).then(t2 => {
          const {
            quote,
            review
          } = t2;
          if (controller.signal.aborted) {
            return;
          }
          onQuote(operationId, quote, review);
          if (!review.challenge) {
            setError(null);
          }
        }).catch(failure => {
          if (!controller.signal.aborted) {
            const details = providerFailure(failure);
            setProviderFailure(details);
            setError(details?.category ?? "provider_unavailable");
          }
        }).finally(() => {
          if (active.current === controller) {
            active.current = null;
          }
        });
      }, 10000);
      return () => {
        clearInterval(timer);
        controller.abort();
      };
    };
    t1 = [enabled, operation, operationId, provider, active, onQuote, setError, setProviderFailure];
    $[0] = active;
    $[1] = enabled;
    $[2] = onQuote;
    $[3] = operation;
    $[4] = operationId;
    $[5] = provider;
    $[6] = setError;
    $[7] = setProviderFailure;
    $[8] = t0;
    $[9] = t1;
  } else {
    t0 = $[8];
    t1 = $[9];
  }
  useEffect(t0, t1);
}